import { Target, TrendingUp, Trophy } from "lucide-react";

/** Flat, hairline stat card — numeric-tabular, Uber-style. */
const Stat = ({ label, value, Icon, testid, delay = 0, accent = "foreground" }) => (
  <div
    className="nd-card nd-card-hover p-5 sm:p-6 nd-fade-up"
    style={{ animationDelay: `${delay}s` }}
    data-testid={testid}
  >
    <div className="flex items-start justify-between gap-4">
      <div className="min-w-0">
        <p className="eyebrow truncate">{label}</p>
        <p
          className={`mt-2 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight font-tabular ${
            accent === "primary" ? "text-primary" : "text-foreground"
          }`}
        >
          {value}
        </p>
      </div>
      <div className="h-10 w-10 rounded-xl bg-muted flex items-center justify-center shrink-0">
        <Icon className="w-4.5 h-4.5 text-foreground" />
      </div>
    </div>
  </div>
);

export const StatsCards = ({ predictions = [] }) => {
  const avgConfidence =
    predictions.length > 0
      ? (
          predictions.reduce((acc, p) => {
            const top = p.top_predictions?.[0];
            return acc + (top?.confidence || 0);
          }, 0) / predictions.length
        ).toFixed(1) + "%"
      : "—";

  const highCount = predictions.filter((p) =>
    p.top_predictions?.some((tp) => tp.confidence >= 75)
  ).length;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-5 mb-10">
      <Stat
        label="Predictions loaded"
        value={predictions.length}
        Icon={Target}
        testid="stat-predictions-today"
        delay={0.0}
      />
      <Stat
        label="Avg confidence"
        value={avgConfidence}
        Icon={TrendingUp}
        testid="stat-avg-confidence"
        delay={0.05}
        accent="primary"
      />
      <Stat
        label="High-confidence picks"
        value={highCount}
        Icon={Trophy}
        testid="stat-high-confidence"
        delay={0.1}
      />
    </div>
  );
};

export default StatsCards;
